import * as types from '../actions/actionTypes';
import initialState from './initialState';
import pull from 'lodash/pull';

export default function gigReducer(state = initialState.gigState, action) {
    switch(action.type) {
        case types.GET_GIG:   
        {        
            const gig = action.gig;
            return {
                ...state,
                gig
            };
        }
        case types.GET_GIG_STATUS:
            return {
                ...state,
                gigLoadingStatus: action.loadingStatus.status
            };
        case types.SET_GIG_BROWSE_DATES:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        startDate: action.dates.startDate,
                        endDate: action.dates.endDate
                    }
                }
            };
        }
        case types.SET_GIG_BROWSE_TAB:
        {
            return {
                ...state,
                browse: { ...state.browse, selectedTab: action.selectedTab}
            };
        }
        case types.SET_GIG_KEYWORD:
        {
            return {
                ...state,
                browse: { ...state.browse, keyword: action.keyword}
            };
        }
        case types.CLEAR_GIG_KEYWORD:
        {
            return {
                ...state,
                browse: { ...state.browse, keyword: ''}
            };
        }
        case types.BROWSE_GIG_STATUS: 
        {
            return {
                ...state,
                browse: { ...state.browse, loadingStatus: action.loadingStatus}
            };
        }
        case types.SET_GIG_BROWSE_RESULTS:
        {
            const items = [...state.browse.results.items].concat(action.results.items);
            const results = {...action.results, items};
            return {
                ...state,
                browse: { ...state.browse, results}
            };
        }
        case types.CLEAR_GIG_BROWSE_RESULTS:
        {
            return {
                ...state,
                browse: { ...state.browse, loadingStatus: null, results: initialState.artistState.browse.results}
            };
        }
        case types.CLEAR_GIG_SEARCH_CRITERIA:
        {
            return {
                ...state,
                browse: { ...state.browse, searchCriteria: initialState.artistState.browse.searchCriteria, keyword: initialState.artistState.browse.keyword}
            };
        }
        case types.SET_GIG_SEARCH_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, searchError: action.error.message}
            };
        }
        case types.CLEAR_GIG_SEARCH_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, searchError: null}
            };
        }
        case types.SET_GIG_BROWSE_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, browseError: action.error.message}
            };
        }
        case types.CLEAR_GIG_BROWSE_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, browseError: null}
            };
        }
        case types.SET_GIG_BROWSE_SORT:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        sort: action.sortField
                    }
                }
            };
        }
        case types.SET_GIG_BROWSE_ADD_GENRE:
        {
            const selectedGenres = [...state.browse.searchCriteria.selectedGenres];
            selectedGenres.push(action.genre);
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedGenres
                    }
                }
            };
        }
        case types.SET_GIG_BROWSE_REMOVE_GENRE:
        {
            const selectedGenres = [...state.browse.searchCriteria.selectedGenres];
            pull(selectedGenres, action.genre);
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedGenres
                    }
                }
            };
        }      
        case types.SET_GIG_BROWSE_DISTANCE:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        distance: action.distance
                    }
                }
            };
        }
        case types.SET_GIG_BROWSE_DISTANCE_UNIT:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        distanceUnit: action.unit
                    }
                }
            };
        }
        case types.SET_GIG_BROWSE_LOCATION:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        location: action.location
                    }
                }
            };
        }      
        case types.CLEAR_PROFILE_GIGS:
        {
            debugger;
            //if we have a gig for the profile loaded, clear it to force a reload
            if(state.gig && state.gig.Artists[action.profile.username]) {
                return {
                    ...state,
                    gig: null
                };
            }
            else {
                return state;
            }
        }    
        default:
            return state;
    }
}